<template>
    <div>
        <div class="content-header case-search-header">
            <div class="content-header-left">
                <div class="search">
                    <vs-input
                        :key="'searchtxt'"
                        icon-pack="feather"
                        icon="icon-search"
                        v-model.lazy="searchtxt"
                        placeholder="Search by Employee Name/Email"
                        class="is-label-placeholder"
                    />
                </div>
            </div>
            <div class="content-header-right">
                <vs-inv-dropdown>
                    <div class="filters-content">
                        <div class="filters-form-fileds noscroll">
                            <div class="form-container">
                                <div class="vx-row">
                                    <selectField :closeOnSelect="false" :multiple="true" :display="true" :wrapclass="'md:w-1/3'" :label="'Event Type'" :required="false" :cid="'selectedEventTypes'" :optionslist="eventTypeList" v-model="selectedEventTypes" fieldName="selectedEventTypes" placeHolder="Select Event Type"/>
                                    <div class="vx-col md:w-1/3 w-full con-select">
                                        <label class="typo__label">Created On</label>
                                        <date-range-picker :append-to-body="true" :autoApply="autoApply" :ranges="false" :maxDate="new Date()" v-model="selectedDateRange"></date-range-picker>
                                    </div>
                                    <div class="vx-col md:w-1/3 w-full con-select">
                                        <label class="typo__label">Actor</label>
                                        <multiselect
                                            v-model="selectedActors"
                                            :options="actorsList"
                                            :multiple="true"
                                            :hideSelected="true"
                                            :close-on-select="false"
                                            :clear-on-select="false"
                                            :preserve-search="true"
                                            :select-label="''"
                                            placeholder="Select Actor"
                                            label="name"
                                            track-by="_id"
                                            :preselect-first="false"
                                        >
                                        <template slot="selection" slot-scope="{ values, isOpen }">
                                            <span class="multiselect__selectcustom" v-if="values.length && !isOpen" >{{ values.length }} options selected</span>
                                            <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                                        </template>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="filters-status">
                            <div class="left-buttons">
                            </div>
                            <div class="right-buttons">
                                <button color="success" class="btn light_blue_btn" type="filled" v-on:click="set_filter">Apply</button>
                                <button color="dark" class="btn gray_btn mr-3" type="filled" v-on:click="clear_filter($event)">Clear </button>
                            </div>
                        </div>
                    </div>
                </vs-inv-dropdown>
            </div>
        </div>
        <NoDataFound ref="NoDataFoundRef" :checkLocading="isListloading" v-if="auditLogs.length == 0" content="" :heading="'No audit logs available yet'" type='petitioner' />
        <div class="accordian-table paf_table" v-if="auditLogs.length > 0">
            <vs-table :data="auditLogs">
                <template slot="thead">
                    <vs-th>
                        <a class="nowrap" >Date/time</a>
                    </vs-th>
                    <vs-th>
                        <a class="nowrap" >Actor</a>
                    </vs-th>
                    <vs-th>
                        <a class="nowrap" >Action</a>
                    </vs-th>
                    <vs-th>
                        <a class="nowrap" >Before → After Values</a>
                    </vs-th>
                    <vs-th>
                        <a class="nowrap" >Employee name</a>
                    </vs-th>
                </template>
                <template slot-scope="{data}">
                    <vs-tr :data="log" :key="index" v-for="(log, index) in auditLogs">
                        <vs-td :data="log" class="cursor-pointer">
                            <span>{{ checkProperty(log, 'createdOn') | formatDateTime }}</span>
                        </vs-td>
                        <vs-td :data="log" class="cursor-pointer">
                            <span>{{ checkProperty(log, 'createdByName') }}</span>
                        </vs-td>
                        <vs-td :data="log" class="cursor-pointer">
                            <span>{{ checkProperty(log, 'eventType') }}</span>
                        </vs-td>
                        <vs-td :data="log" class="cursor-pointer">
                            <span v-if="checkProperty(log, 'eventType') === 'Edit Termination' && checkProperty(log, 'beforeState', 'oldStatus') && checkProperty(log, 'afterState', 'newStatus')">{{ `${formatDate(checkProperty(log, 'beforeState', 'oldStatus'))} → ${formatDate(checkProperty(log, 'afterState', 'newStatus'))}` }}</span>
                            <span v-else-if="checkProperty(log, 'eventType') !== 'Resend Invite' && checkProperty(log, 'beforeState', 'oldStatusName') && checkProperty(log, 'afterState', 'newStatusName')">{{ `${checkProperty(log, 'beforeState', 'oldStatusName')} → ${checkProperty(log, 'afterState', 'newStatusName')}` }}</span>
                            <span v-else>--</span>
                        </vs-td>
                        <vs-td :data="log" class="cursor-pointer">
                            <span>{{ checkProperty(log, 'employeeName') | empty }}</span>
                        </vs-td>
                        <template class="expand-user" slot="expand">
                            <div class="con-expand-users">
                                <div>
                                    <vs-table :data="log" :no-data-text="'No IP and User Agent details found'">
                                        <template slot="thead">
                                            <vs-th>IP Address</vs-th>
                                            <vs-th>Country</vs-th>
                                            <vs-th>Browser</vs-th>
                                            <vs-th>Operating System</vs-th>
                                            <vs-th>User Agent</vs-th>
                                        </template>
                                        <template>
                                            <vs-tr>
                                                <vs-td>
                                                    <span style="cursor:pointer">{{ checkProperty(log, 'ipInfo', 'ip') | empty }}</span>
                                                </vs-td>
                                                <vs-td>
                                                    <span style="cursor:pointer">{{ checkProperty(log, 'ipInfo', 'country') | empty }}</span>
                                                </vs-td>
                                                <vs-td>
                                                    <span v-if="checkProperty(log, 'deviceInfo', 'browser') && checkProperty(log['deviceInfo'], 'browser', 'name') && checkProperty(log['deviceInfo'], 'browser', 'version')" style="cursor:pointer">{{ `${checkProperty(log['deviceInfo'], 'browser', 'name')} ${checkProperty(log['deviceInfo'], 'browser', 'version')}` }}</span>
                                                    <span v-else>--</span>
                                                </vs-td>
                                                <vs-td>
                                                    <span v-if="checkProperty(log, 'deviceInfo', 'os') && checkProperty(log['deviceInfo'], 'os', 'name') && checkProperty(log['deviceInfo'], 'os', 'version')" style="cursor:pointer">{{ `${checkProperty(log['deviceInfo'], 'os', 'name')} ${checkProperty(log['deviceInfo'], 'os', 'version')}` }}</span>
                                                    <span v-else>--</span>
                                                </vs-td>
                                                <vs-td>
                                                    <span style="cursor:pointer">{{ checkProperty(log, 'deviceInfo', 'ua') | CapSubString | empty }}</span>
                                                </vs-td>
                                            </vs-tr>
                                        </template>
                                    </vs-table>
                                </div>
                            </div>
                        </template>
                    </vs-tr>
                </template>
            </vs-table>
             <div class="table_footer">
                <div class="vx-col con-select pages_select" v-if="auditLogs.length > 0">
                <label class="typo__label">Per Page</label>
                <multiselect
                    @input="changeperPage()"
                    v-model="perpage"
                    :options="perPeges"
                    :multiple="false"
                    :allow-empty="false"
                    :close-on-select="true"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Per Page"
                    :preselect-first="true"
                >
                </multiselect>
                <span class="totla_list_count" v-if="auditLogs.length > 0">
                    Total <em>{{ auditLogs.length }}</em></span
                >
                </div>
                <paginate
                    v-if="auditLogs.length > 0"
                    v-model="page"
                    :page-count="totalpages"
                    :page-range="3"
                    :margin-pages="2"
                    :click-handler="pageNate"
                    prev-class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev"
                    next-class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next"
                    :prev-text="'<i></i>'"
                    :next-text="'<i></i>'"
                    :container-class="'pagination vs-pagination--nav'"
                    :page-class="'page-item'"
                ></paginate>
            </div>
        </div>
    </div>
</template>
<script>
    import DateRangePicker from "vue2-daterange-picker";
    import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
    import vsInvDropdown from "@/views/vs-inv-dropdown.vue";
    import selectField from "@/views/forms/fields/simpleselect.vue";
    import NoDataFound from "@/views/common/noData.vue";
    import moment from "moment";
    import Paginate from "vuejs-paginate";

    export default {
        name: 'audit-log',
        components: {
            selectField,
            vsInvDropdown,
            DateRangePicker,
            NoDataFound,
            Paginate
        },
        provide() {
            return {
                parentValidator: this.$validator,
            };
        },
        data(){
            return {
                page: 1,
                perPeges: [10, 25, 50, 75, 100],
                perpage: 25,
                auditLogs: [],
                totalpages: 0,
                isListloading: false,
                searchtxt: '',
                debounce: null,
                selectedEventTypes: [],
                finalSelectedEventTypes: [],
                autoApply: '',
                selectedDateRange: {
                    startDate: null,
                    endDate: null
                },
                finalSelectedDateRange: [],
                selectedActors: [],
                finalSelectedActors: [],
                actorsList: [],
                eventTypeList: [{id: 1, name: 'Terminate'},{id: 2, name: 'Edit Termination'},{id: 3, name: 'Undo Termination'},{id: 4, name: 'Invalidate'},{id: 5, name: 'Restore'},{id: 6, name: 'Resend Invite'}]
            }
        },
        watch: {
            searchtxt: function (value) {
                this.searchMe();
            },
        },
        mounted(){
            this.getAuditLogs()
            this.getActorsList()
        },
        methods: {
            pageNate(pageNum) {
                this.page = pageNum;
                this.getAuditLogs();
            },
            changeperPage() {
                this.page = 1;
                this.getAuditLogs();
            },
            formatDate(date){
                if (date) {
                    return moment.utc(date).format('MMM DD, YYYY')
                }
            },
            getAuditLogs(){
                this.auditLogs = []
                this.isListloading = true
                let payload = {
                    matcher: {
                        searchString: this.searchtxt,
                        createdDateRange: this.finalSelectedDateRange,
                        actors: this.finalSelectedActors,
                        eventTypes: this.finalSelectedEventTypes
                    },
                    page: this.page,
                    perpage: this.perpage
                }
                this.$store.dispatch('commonAction', {data: payload, path: '/activity/list'}).then(response =>{
                    if(response && response.list){
                        this.auditLogs = response.list
                        this.totalpages = Math.ceil(this.auditLogs.length / this.perpage);
                    }
                }).catch(error => {
                    console.log('ERROR: ', error)
                }).finally(() => {
                    this.isListloading = false
                })
            },
            set_filter(){
                document.body.classList.remove('scroll-hidden')
                if(this.checkProperty(this.selectedEventTypes, 'length') > 0){
                    this.finalSelectedEventTypes = this.selectedEventTypes.map(eventType => this.checkProperty(eventType, 'name'))
                }
                if(this.checkProperty(this.selectedDateRange, 'startDate') && this.checkProperty(this.selectedDateRange, 'endDate')){
                    this.finalSelectedDateRange = [this.checkProperty(this.selectedDateRange, 'startDate'), this.checkProperty(this.selectedDateRange, 'endDate')]
                }
                if(this.checkProperty(this.selectedActors, 'length') > 0){
                    this.finalSelectedActors = this.selectedActors.map(actor => this.checkProperty(actor, '_id'))
                }
                this.getAuditLogs()
            },
            clear_filter(){
                document.body.classList.remove('scroll-hidden')
                this.searchtxt = ''
                this.selectedEventTypes = []
                this.finalSelectedEventTypes = []
                this.selectedActors = []
                this.finalSelectedActors = []
                this.selectedDateRange = {}
                this.finalSelectedDateRange = []
                this.getAuditLogs()
            },
            searchMe() {
                let self = this;
                clearTimeout(this.debounce);
                this.debounce = setTimeout(() => {
                    self.page = 1;
                    self.getAuditLogs();
                }, 900);
            },
            getActorsList(){
                this.actorsList = []
                let payload = {
                "matcher": {
                    "petitionerIds": [this.getUserData.companyId],
                    "statusIds": [2]
                    },
                    "sorting": {
                        "path": "createdOn",
                        "order": -1
                    },
                    "page": 1,
                    "perpage": 1000,
                    "forBilling": true
                }
                this.$store.dispatch( 'getList',{path: '/users/get-i9-signers',data: payload}).then(response=>{
                    this.actorsList = this.checkProperty(response, 'list')
                }).catch(err=>{
                    console.log('ERROR: ', err)
                })
            },
        }
    }
</script>